import Results from "./catalog/Results.vue";
import Vue from "vue";

$(document).ready(function () {
  // find shortcode hidden elements
  const shortcodeEls = document.querySelectorAll("[data-shortcode]");

  for (const el of shortcodeEls) {
    // get shortcode data
    const jsonString = el.getAttribute("data-shortcode");
    const shortcode = JSON.parse(jsonString);

    // create new Results component
    const Component = Vue.extend(Results);
    const instance = new Component({
      propsData: shortcode.uiParams,
    });

    instance.filter = { ...window.FILTER, data: shortcode.params };

    // mount element
    instance.$mount(el);
  }
});
